module.exports = __webpack_public_path__ + "media/saved.871e150e.wav";